import {IconProp} from "@fortawesome/fontawesome-svg-core";
import * as React from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormattedMessage, MessageDescriptor} from "react-intl";

type SectionProps = {
    icon?: IconProp;
    label: MessageDescriptor;
    children: React.ReactNode;
    labelExtra?: React.ReactNode;
    hidden?: boolean;
};

export default function Section({children, icon, label, labelExtra, hidden}: SectionProps) {
    function getIcon() {
        return icon ? <FontAwesomeIcon size="lg" icon={icon} style={{marginRight: 10}} /> : null;
    }

    if (hidden) return null;

    return (
        <Grid container direction="column">
            <Grid size={12}>
                <div style={{display: "flex", alignItems: "center"}}>
                    {getIcon()}
                    <div style={{marginRight: 10}}>
                        <Typography variant="h6">
                            <FormattedMessage {...label} />
                        </Typography>
                    </div>
                    {labelExtra}
                    <Divider style={{flexGrow: 1}} />
                </div>
            </Grid>
            {children}
        </Grid>
    );
}

/**
 * The same as Section but implemented with Grid2.
 */
export function Section2({children, icon, label, labelExtra, hidden}: SectionProps) {
    function getIcon() {
        return icon ? <FontAwesomeIcon size="lg" icon={icon} style={{marginRight: 10}} /> : null;
    }

    if (hidden) return null;

    return (
        <Grid container>
            <Grid size={12}>
                <div style={{display: "flex", alignItems: "center"}}>
                    {getIcon()}
                    <div style={{marginRight: 10}}>
                        <Typography variant="h6">
                            <FormattedMessage {...label} />
                        </Typography>
                    </div>
                    {labelExtra}
                    <Divider style={{flexGrow: 1}} />
                </div>
            </Grid>
            {children}
        </Grid>
    );
}
